module.exports = __webpack_public_path__ + "img/npl.b66578a5.svg";